var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorAdministration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m33.565,21.542c.008-.18.012-.36.012-.542s-.004-.362-.012-.542l4.352-3.492c.385-.309.488-.853.24-1.281l-3.976-6.887c-.247-.428-.769-.612-1.23-.432l-6.007,2.337-.979-6.37c-.075-.488-.495-.849-.989-.849h-7.952c-.494,0-.914.361-.989.849l-.979,6.37-6.007-2.337c-.46-.179-.983.004-1.23.432l-3.976,6.887c-.247.428-.145.972.24,1.281l4.352,3.492c-.008.18-.012.36-.012.542s.004.362.012.542l-4.352,3.492c-.385.309-.488.853-.24,1.281l3.976,6.887c.247.428.769.611,1.23.432l6.007-2.337.979,6.37c.075.488.495.849.989.849h7.952c.494,0,.914-.361.989-.849l.979-6.37,6.007,2.337c.46.179.983-.005,1.23-.432l3.976-6.887c.247-.428.145-.972-.24-1.281l-4.352-3.492Zm-12.565,4.541c-2.623,0-4.75-2.127-4.75-4.75s2.127-4.75,4.75-4.75,4.75,2.127,4.75,4.75-2.127,4.75-4.75,4.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorAdministration);
export default __webpack_public_path__ + "static/media/indoor-administration.d2fa0b42f1af78e098965a4e857dd78c.svg";
export { ForwardRef as ReactComponent };